/*
 * @Description: 内网通信统一封装
 * @Date: 2019-12-09 10:40:39
 */
import store from '../../store'

/**
 * @Description: 向发送发送事件
 * id、event事件类型、payload[object]额外参数
 * @return: null
 */
const sendMessage = (event, payload = null) => {
    // 不同步login的跳转
    if (event == 'syncUrl' && payload.url && (payload.url.indexOf('/login') != -1 || payload.url.indexOf('/meeting/') != -1 || payload.url.endsWith('/pipeline/list'))) {
        return;
    }
    const config = {
        event: event,
        params: payload,
        code: store.state.code,
    }
    window.parent.postMessage(config, '*');
}


export default sendMessage;